import { render, staticRenderFns } from "./noticeItemBottomBtn.vue?vue&type=template&id=7d8535eb&scoped=true&"
import script from "./noticeItemBottomBtn.vue?vue&type=script&lang=js&"
export * from "./noticeItemBottomBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8535eb",
  null
  
)

export default component.exports